module.exports = "\r\n.small-icon img{\r\n    width: 30px;\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component.css
// module id = ./src/app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component.css
// module chunks = main